import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import { AppShell } from '@/components/layout/app-shell';
import { routes } from '@/config/routes';

import { RequireAuth } from './guards/require-auth';

const lazy =
  <K extends string>(loader: () => Promise<Record<K, ComponentType>>, key: K) =>
  async () => {
    const m = await loader();
    return { Component: m[key] };
  };

export const protectedRoutes: RouteObject[] = [
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppShell />,
        children: [
          { path: routes.home, element: <Navigate to={routes.devices} replace /> },
          {
            path: routes.devices,
            lazy: lazy(() => import('@/pages/devices/devices.page'), 'DevicesPlaceholderPage'),
          },
          {
            path: routes.device(),
            lazy: lazy(
              () => import('@/pages/device-detail/device-detail.page'),
              'DeviceDetailPlaceholderPage',
            ),
          },
          {
            path: routes.map,
            lazy: lazy(() => import('@/pages/map/map.page'), 'MapPlaceholderPage'),
          },
          {
            path: routes.subscriptions,
            lazy: lazy(
              () => import('@/pages/subscriptions/subscriptions.page'),
              'SubscriptionsPlaceholderPage',
            ),
          },
          {
            path: routes.support,
            lazy: lazy(() => import('@/pages/support/support.page'), 'SupportPlaceholderPage'),
          },
          {
            path: routes.ticket(),
            lazy: lazy(() => import('@/pages/support/ticket.page'), 'TicketPlaceholderPage'),
          },
          {
            path: routes.notifications,
            lazy: lazy(
              () => import('@/pages/notifications/notification-settings.page'),
              'NotificationSettingsPlaceholderPage',
            ),
          },
          {
            path: routes.profile,
            lazy: lazy(() => import('@/pages/profile/profile.page'), 'ProfilePlaceholderPage'),
          },
        ],
      },
    ],
  },
];
